import React, { useContext, useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ArrowRightCircle, CheckCircle, XLg } from 'react-bootstrap-icons'
import axiosService from '../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import { Formik, Form } from 'formik'
import { useParams } from 'react-router-dom'
import DraftComment from '../../../../../../models/DraftComment'
import DraftLocationComment from '../../../../../ProjectManager/Campaign/CampaignPageParts/DraftProcessParts/ReviewWindowParts/DraftCommentsParts/DraftLocationComment'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'

export default observer(function DraftCommentModal({ isOpen, onClose, location, goToCommentTime }) {
  const { id, action_id } = useParams()
  const { selectedUpload } = useContext(SharedCampaignContext)
  const [isAccepted, setIsAccepted] = useState(location.isAccepted)
  const commentsContainerRef = useRef(null)
  const modalRef = useRef()

  const createComment = (draft_comment) => {
    axiosService.post(
      `/api/advertiser/campaign_share/draft_uploads/${selectedUpload.id}/draft_comment_locations/${location.id}/client_draft_comments`,
      { draft_comment }
    )
      .then(comment => {
        location.comments.push(new DraftComment(comment))
      })
      .catch(() => toastError('Could not add comment'))
  }

  const deleteComment = (comment) => {
    axiosService.delete(`/api/advertiser/campaign_share/draft_uploads/${selectedUpload.id}/draft_comment_locations/${location.id}/client_draft_comments/${comment.id}`)
      .then((removedComment) => {
        location.comments = location.comments.filter(comment => comment.id !== removedComment.id)
        toastSuccess('Comment removed!')
      })
      .catch((response) => toastError(response.data.error))
  }

  const getComments = () => {
    axiosService.get(`/api/project_manager/campaigns/${id}/actions/${action_id}/draft_uploads/${selectedUpload.id}/draft_comment_locations/${location.id}/draft_comments`)
      .then(comments => {
        location.comments = comments.map(comment => new DraftComment(comment))
      })
      .catch(error => console.log(error))
  }

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose(event)
    }
  }

  const handleAcceptComment = () => {
    setIsAccepted(true)
    axiosService.patch(
      `/api/project_manager/campaigns/${id}/actions/${action_id}/draft_uploads/${selectedUpload.id}/draft_comment_locations/${location.id}`,
      {location: { is_accepted: true } }
    )
      .then((updatedLocation) => {
        setTimeout(() => {
          selectedUpload.commentLocations = selectedUpload.commentLocations.filter(location => location.id !== updatedLocation.id)
        }, 200);
        })
      .catch(() => toastError('Could not accept comments'))
  }

  useEffect(() => getComments(), [selectedUpload.id])

  useEffect(() => {
    // Scroll to the bottom of the comments list whenever the comments change
    if (commentsContainerRef.current) {
      commentsContainerRef.current.scrollTop = commentsContainerRef.current.scrollHeight;
    }
  }, [location.comments.length]);

  useEffect(() => {
    isOpen ?
      document.addEventListener('mousedown', handleClickOutside) :
      document.removeEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen])

  if (!isOpen) return null
  console.log(location)
  return (
    isOpen && (
    <div
      ref={modalRef}
      className='flex flex-col gap-1 shadow z-30 absolute -bottom-[40px] left-[48px] w-[300px] max-h-[400px] rounded-2xl text-white overflow-x-visible'
      style={{ backgroundColor: '#2D3332' }}
    >

      <div className='flex items-center justify-between p-3 border-b-1 border-rb-dark-mode-lighter'>

        <p className="text-white font-semibold text-sm">Comment</p>
        {
          location.time && (
            <div className='flex items-center'>
              <p className="text-white font-semibold text-xs mr-1">at:</p>
              <span onClick={() => goToCommentTime(location.time)} className='hover:cursor-pointer text-rb-green text-sm underline mr-1'>{location.time.toFixed(2)}</span>
              <p className="text-white font-semibold text-xs">seconds</p>
            </div>
          )
        }
        <div className="flex gap-2 items-center">
          <button onClick={handleAcceptComment} >
            <CheckCircle className={`${isAccepted ? 'text-rb-green' : 'text-white'} text-md`} />
          </button>
          <button onClick={onClose}>
            <XLg className='text-md'/>
          </button>
        </div>

      </div>

      <div ref={commentsContainerRef} className='p-2 max-h-[375px] overflow-y-auto overflow-x-visible'>
        {
          location.comments.map((comment, index) => <DraftLocationComment key={index} comment={comment} deleteComment={deleteComment} />)
        }
      </div>

      <div className='p-2 flex gap-2 items-center'>
        <img src={location.locationOwnerAvatar} className="h-8 w-8 rounded-full object-cover"/>
        <div className="bg-rb-dark-mode-lighter flex-grow rounded-lg">
          <Formik
            initialValues={{comment: ''}}
            onSubmit={(values, { resetForm }) => {
              createComment(values)
              resetForm()
            }}
          >
            {({ handleBlur, handleChange, values }) => (
              <Form>
                <div className="flex justify-between pr-2">
                  <textarea
                      name='comment'
                      rows="1"
                      className='bg-rb-dark-mode-lighter rounded-lg border-none focus:ring-transparent placeholder:text-rb-lighter-grey flex-grow'
                      placeholder='Comment'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.comment}
                      style={{ resize: 'none' }}
                  />
                  <button type="submit">
                    <ArrowRightCircle className='hover:text-rb-green'/>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
    )
  )
})
